export const REGEX = {
  ALPHANUMERIC: /^[a-zA-ZñÑáéíóúüÁÉÍÓÚÜ']$/,
  ALPHANUMERIC_AND_DOTS: /^[a-zA-ZñÑáéíóúüÁÉÍÓÚÜ.']$/,
  REMOVE_SPECIAL_CHARS: /[^a-zA-ZñÑáéíóúüÁÉÍÓÚÜ0-9\s]/g,
  NUMBERS: /^[0-9]$/,
  NUMERIC_ZIP_CODE: /^\d{4}$/,
  ALPHANUMERIC_ZIP_CODE: /^[A-Za-z]{1}\d{4}[A-Za-z]{3}$/,
};

export const PDF = {
  A4 : 'assets/pdf/cdd-short-frente2.pdf',
  LEGAL_FRONT: 'assets/pdf/cdd-legal-frente2.pdf',
  EMPTY_LEGAL: 'assets/pdf/cdd-empty-legal.pdf',
  LEGAL_DORSO: 'assets/pdf/cdd-legal-dorso.pdf'
}

export enum StateFormalNotice {
  pending = 'Pendiente',
  send = 'Enviada',
  draft = 'Borrador',
  printed = 'Impresa',
  queue = 'EnCola'
}

export enum StateButton {
  pending = 'pending',
  printed = 'printed'
}

export enum Roles {
  agent = 'apoderado',
  redactor = 'redactor',
  operator = 'operador',
  ocasaAdmin = 'adminOcasa',
  clientAdmin = 'adminCliente',
  auditor = 'auditor'
}

export enum Search {
  name= 'name',
  date= 'date',
  dni= 'dni',
  area= 'area',
  nombreCliente = 'nombreCliente' 
}

export enum UserActions {
  print = 'print',
  download = 'download',
  preview = 'preview'
}
